module.exports = __webpack_public_path__ + "static/media/ufo.352c43a0.svg";